import NiceModal from '@ebay/nice-modal-react';
import dynamic from 'next/dynamic';
import { WithdrawalType } from './constants';

const MODAL_ID = 'withdrawal-detail-modal';
let isRegistered = false;

async function ensureModalRegistered() {
  if (isRegistered) return;
  const modalModule = await import('./withdrawal-detail-modal');
  NiceModal.register(MODAL_ID, modalModule.default);
  isRegistered = true;
}

// 导出枚举，供外部使用
export { WithdrawalType } from './constants';

/**
 * 显示提现详情模态框（按需加载）
 * 
 * 仅在需要展示时，才动态加载和注册组件，减少首屏体积。
 */
export const showWithdrawalDetailModal = async (params: { order_id: string; type: WithdrawalType; }) => {
  await ensureModalRegistered();
  return NiceModal.show(MODAL_ID, params);
};

// 如需在 JSX 中直接引用，也提供 dynamic 版本，保持按需加载（仅客户端渲染）
export const WithdrawalDetailModal = dynamic(() => import('./withdrawal-detail-modal'), { ssr: false });
export default WithdrawalDetailModal;

